const Races = () => {
  const races = [
    { id: 1, name: 'Гран-при России', date: '2024-06-15', location: 'Сочи' },
    { id: 2, name: 'Ралли Шелковый путь', date: '2024-07-01', location: 'Москва-Казань' },
    { id: 3, name: 'Кубок чемпионов', date: '2024-08-20', location: 'Санкт-Петербург' },
  ];

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Гонки и соревнования</h1>
      <div style={{ marginTop: '2rem' }}>
        {races.map(race => (
          <div 
            key={race.id} 
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '1rem'
            }}
          >
            <h3>{race.name}</h3>
            <p>Дата: {race.date}</p>
            <p>Место проведения: {race.location}</p>
            <button 
              style={{
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                padding: '0.5rem 1rem',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Подробнее
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Races; 